import { parseDateSafe } from "./zodUtils.mjs";
import { CLINICAL_BOOKING_HORIZON_WEEKS } from "../models/consultation/clinicalAvailability.mjs";
import { DateTime } from "luxon";

// src/utils/bridgeInsuranceConsentFreshness.ts
/** Last calendar day a clinical consult can be scheduled (start of that day in `zone`). */
function resolveMaximumConsultationDateStart(zone, at = /* @__PURE__ */ new Date(), options) {
	const safeZone = zone || "UTC";
	const weeks = options?.horizonWeeks ?? 4;
	return DateTime.fromJSDate(at, { zone: safeZone }).plus({ weeks }).startOf("day");
}
/**
* Bridge consent is fresh when `consentedAt` is strictly after one calendar year
* before the maximum consultation date.
*/
function isBridgeConsentFreshForMaximumConsultationDate(consentedAt, zone, at = /* @__PURE__ */ new Date(), options) {
	const consentDate = parseDateSafe(consentedAt);
	if (!consentDate) return false;
	const safeZone = zone || "UTC";
	const cutoff = resolveMaximumConsultationDateStart(safeZone, at, options).minus({ years: 1 });
	return DateTime.fromJSDate(consentDate, { zone: safeZone }) > cutoff;
}

export { isBridgeConsentFreshForMaximumConsultationDate, resolveMaximumConsultationDateStart };
//# sourceMappingURL=bridgeInsuranceConsentFreshness.mjs.map